<script>
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
    extends: Line,
    mixins: [reactiveProp],
    props: {
        chartData: {
            type: Object,
            default: null
        },
    },
    data: () => ({
        options: {
            responsive: true,

            legend: {
                display: false,
            },
            maintainAspectRatio: false,
            scales: {
                yAxes: [
                    {
                        ticks: {
                            fontColor: '#1d232d',
                            beginAtZero: true,
                            fontSize: 8,
                            padding: 24,
                            precision: 0
                        },
                        gridLines: {
                            drawTicks: false,
                            drawBorder: false,
                            color: '#c1c8ce',
                            borderDash: [2],
                            zeroLineColor: '#c1c8ce',
                            zeroLineBorderDash: [2]
                        },

                    }
                ],
                xAxes: [
                    {
                        ticks: {
                            fontColor: '#1d232d',
                            fontFamily: 'Open Sans',
                            fontSize: 8,
                            padding: 10,
                            stepSize: 5,
                            maxTicksLimit: 6
                        },
                        gridLines: {
                            display: false,
                        },

                    }
                ]
            }
        },
    }),
    mounted() {
        this.renderChart(this.chartData, this.options)
    },
    watch: {
        chartData: function () {
            this.renderChart(this.chartData, this.options)
        }
    }
}
</script>